import { forwardRef } from "react";

export function forwardRefWithGeneric<T, P = {}>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode | null
): (props: P & React.RefAttributes<T>) => React.ReactNode | null {
  return forwardRef(render as any) as any;
}
